import { default as __WEBPACK_EXTERNAL_MODULE__components_waze_copy_template_button_08e84bcc_default__ } from "../components/waze-copy-template-button";
import { withPluginApi as __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__ } from "discourse/lib/plugin-api";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "../components/waze-copy-template-button"

;// external "discourse/lib/plugin-api"

;// ./src/plugin/assets/javascripts/discourse/initializers/waze-templates-intializer.ts


/* harmony default export */ const waze_templates_intializer = ({
    name: "waze-templates",
    initialize(_container, _app) {
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__("2.0.0", (api) => {
            api.registerValueTransformer("post-menu-buttons", ({ value: dag, context }) => {
                const post = context.post;
                if (post.wiki) {
                    dag.add("waze-copy-template-button", __WEBPACK_EXTERNAL_MODULE__components_waze_copy_template_button_08e84bcc_default__, {
                        after: context.lastButtonKey,
                    });
                }
            });
        });
    },
});

export { waze_templates_intializer as default };
